module.exports = __webpack_public_path__ + "img/img_tag_sucai.eaff470c.svg";